import posthog from 'posthog-js'

const initPosthog = () => {
  const userElement = document.getElementById('user-data');
  if (userElement && userElement.dataset.rgpdConsent === 'true') {
    enablePosthog();
  } else {
    disablePosthog();
  }
}

const enablePosthog = () => {
  if (!posthog.__loaded) {
    posthog.init(process.env.POSTHOG_API_KEY, {
      api_host: process.env.POSTHOG_API_URL,
    });
  }

  document.cookie = "ph_optout=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  posthog.opt_in_capturing();
}

const disablePosthog = () => {
  posthog.opt_out_capturing();
  document.cookie = "ph_optout=true; path=/; max-age=31536000";
}

document.addEventListener('turbo:load', () => {
  initPosthog();
});

export { posthog, enablePosthog, disablePosthog }